//import primaryTheme from "../../../themes/primaryTheme";

// Languages
export const languages = [
    {
        name: "English",
        icon: "en",
        locale: "en"
    },

    {
        name: "Français",
        icon: "fr",
        locale: "fr"
    }
];

// Themes
export const themes = [
    {
        id: 1,
        bgColor: "bg-primary",
        theme: ''//primaryTheme
    },
];